import SFetch from '@app/utils/sfetch'

type Title = {
  id: number
  content: string
  size: string
}

export async function create(
  content: string,
  size: string
): Promise<{ title: Title } | null> {
  const url = window.Silverfin.Routes.client_meetings_titles_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return await SFetch.json(url, {
    method: 'POST',
    body: { title: { content, size } },
  })
}

export async function update(
  id: number,
  content: string,
  size: string
): Promise<void> {
  const url = window.Silverfin.Routes.client_meetings_title_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    id
  )

  await SFetch.json(url, {
    method: 'PUT',
    body: { title: { content, size } },
  })
}

export async function remove(id: number): Promise<void> {
  const url = window.Silverfin.Routes.client_meetings_title_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    id
  )

  await SFetch.raw(url, {
    method: 'DELETE',
  })
}
